import { ExtendedLicense } from "../licenses/licenceTypes";

export interface UserInfo {
  total: number;
  limit: number;
  skip: number;
  data: UserData[];
}

export interface GroupsInfo {
  total: number;
  limit: number;
  skip: number;
  data: GroupInfoData[];
}
export interface AssociatedGeoPoint {
  address: null | string;
  altitude: null | number;
  countryName: string | null;
  createdAt: string;
  deletedAt: null | string;
  email: null | string;
  id: number;
  imageFileId: any;
  latitude: null | number;
  longitude: null | number;
  name: string;
  notes: null | string;
  orgId: number;
  primaryContactName: null | string;
  remoteId: string;
  siteLoginUsernamePrimitive: null | string;
  siteLoginsUserId: any;
  sitePassword: null | string;
  telephone: null | string;
  typeId: number;
  updatedAt: null | string;
}

export interface GroupMembership {
  id: number;
  groupId: number;
  userId?: string;
  geoPointId?: number;
  isActive: boolean;
  deletedAt?: string | null;
  membershipType: number;
}

export interface UserData {
  associatedGeoPointId: null | any;
  actionsIds: number[];
  actions: LocalizedTextGrouping[];
  attributeId: any;
  metadata: any;
  remoteId: any;
  userType: string;
  isSuperAdmin: boolean;
  lastAllotedDevice: any;
  emailVerifiedAt: string;
  id: string;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  groups: GroupInfoData[];
  rawGroups: GroupInfoData[];
  licenses?: ExtendedLicense[];
  groupMemberships: GroupMembership[];
  error: string;
  map: any;
  associatedGeoPoint: null | any;
}

export interface GroupInfoData {
  id: any;
  name: string;
  orgId: number;
  groupTemplateId: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  isActive: boolean;
  typeId: number;
}

export enum OrgGroupTypeIds {
  user = 107,
  org = 108,
  backofficeOrg = 109,
  geoPoint = 110,
  // those below aren't auto-created
  backofficeGeoPoint = 111,
  geoPointCluster = 112,
  legacy = 114,
}

export interface UsersRows {
  id: number;
  username: string;
  firstname: string;
  lastname: string;
  groups: any[];
}

export interface LocalizedTextVersionTwo {
  createdAt: string;
  updatedAt: string;
  id: string;
  textId: number;
  localeConstantId: number;
  translation: string;
  locale: {
    createdAt: string;
    updatedAt: string;
    id: number;
    value: string;
    originTableName: string;
    createdBy: string;
  };
}
export interface LocalizedTextGrouping {
  name: any;
  scenarioId: number;
  createdAt: string;
  updatedAt: string;
  id: number;
  slug: string;
  originTableName: string;
  localizedTexts: LocalizedTextVersionTwo[];
}

export interface Scopes {
  createdAt: string;
  updatedAt: string;
  id: string;
  scenarioId: number;
  scopeOrgId: number;
  scopeOrgTypeConstantId: null;
  scopeGroupId: number;
  hasBetaVersionAccess: boolean;
  scenarioAccessibleDirectly: boolean;
  scenarioAccessibleThroughChaining: boolean;
  deletedAt: null;
  createdBy: string;
  deletedBy: null;
  group: {
    createdAt: string;
    updatedAt: string;
    id: number;
    name: string;
    orgId: number;
    isAutoGenerated: true;
    deletedAt: null;
    typeId: number;
    groupTemplateId: number;
  };
}

export interface Method {
  name: LocalizedTextGrouping;
  scopes: Scopes[];
}

export interface SiteUsersConfigRows {
  id: number;
  username: string;
  assignedSite: {
    name: string;
    id?: number | string;
  };
  assignedAction: number[];
  nomadUser: boolean;
  isNew: boolean;
  error?: string;
}
